import axios from 'axios';

export const getAdvertisers = async =>
  axios.get('advertiser/').then(({ data }) => data);
